// Admin overrides for Pokemon metadata.
// These values take precedence over anything in src/data/generated/*.json
// (generated by scripts/fetchGameData.mjs).
//
// Use this file to correct data with real Pokemon Champions info:
// - Learnsets that differ from PokéAPI / Gen 9
// - Abilities added or removed in Pokemon Champions
// - Move usage percentages pulled from in-game battle data
//
// Shape:
//
//   abilities: { "Pokemon Name": { normal: ["Ability"], hidden: ["Ability"] } }
//   learnsets: { "Pokemon Name": ["Move 1", "Move 2", ...] }
//     - If present, REPLACES the generated learnset entirely for that Pokemon.
//       To add without replacing, use learnsetAdditions / learnsetRemovals below.
//   learnsetAdditions: { "Pokemon Name": ["Extra Move", ...] }
//   learnsetRemovals:  { "Pokemon Name": ["Illegal Move", ...] }
//   moveUsage: {
//     "Pokemon Name": {
//       singles: { "Move Name": 72.4, ... },  // percentages 0-100
//       doubles: { "Move Name": 55.1, ... },
//     }
//   }
//
// Names must match ALL_POKEMON entries in src/data/teams.js exactly
// (e.g., "Slowking-Galarian", not "Galarian Slowking").

export const OVERRIDES = {
  abilities: {
    // "Charizard": { normal: ["Blaze"], hidden: ["Solar Power"] },
    "Electrike": { normal: ["Static", "Lightning Rod"], hidden: ["Minus"] },
  },
  learnsets: {
    // "Gyarados": ["Waterfall", "Earthquake", "Dragon Dance", "Ice Fang", ...],
    "Electrike": [
      "Thunder Wave", "Spark", "Bite", "Charge", "Quick Attack", "Howl",
      "Thunderbolt", "Thunder", "Discharge", "Wild Charge", "Volt Switch",
      "Electro Ball", "Crunch", "Flame Burst", "Flamethrower", "Fire Fang",
      "Ice Fang", "Thunder Fang", "Roar", "Snarl", "Swift", "Take Down",
      "Tackle", "Leer", "Odor Sleuth", "Protect", "Substitute", "Rest",
      "Sleep Talk", "Toxic", "Hidden Power", "Light Screen", "Reflect",
      "Switcheroo", "Shock Wave", "Eerie Impulse",
    ],
  },
  learnsetAdditions: {
    // "Dragonite": ["Extreme Speed"],
    "Arcanine-Hisui": ["Head Smash", "Morning Sun"],
    "Floette": ["Light of Ruin"],
    "Umbreon": ["Yawn", "Wish"],
    "Volcarona": ["Morning Sun"],
  },
  learnsetRemovals: {
    // "Clefable": ["Stored Power"],
  },
  moveUsage: {
    // "Gyarados": {
    //   singles: { "Waterfall": 82.3, "Earthquake": 68.1 },
    //   doubles: { "Waterfall": 61.2, "Protect": 88.4 },
    // },
  },
  abilityUsage: {
    // "Gyarados": {
    //   singles: { "Intimidate": 90.0, "Moxie": 10.0 },
    //   doubles: { "Intimidate": 99.0, "Moxie": 1.0 },
    // },
  },
};

export default OVERRIDES;
